<h2 mat-dialog-title>
  {{ 'MY_TASKS.DIALOG-TITLE' | translate }}
</h2>

<mat-dialog-content class="adf-my-tasks-dialog__dialog-content">
  <p>{{ 'MY_TASKS.DIALOG-BODY' | translate }}</p>
</mat-dialog-content>

<mat-dialog-actions class="adf-my-tasks-dialog__actions">
  <button mat-button color="primary" (click)="onYesClick()" [disabled]="actionStarted">
    {{ 'MY_TASKS.YES' | translate }}
  </button>
  <button mat-button color="warn" (click)="onNoClick()">
    {{ 'MY_TASKS.NO' | translate }}
  </button>
</mat-dialog-actions>